var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-layout", { attrs: { row: "", "justify-center": "" } }, [
    _c(
      "div",
      { attrs: { align: "center" } },
      [
        _c(
          "v-flex",
          [
            _c(
              "v-form",
              {
                model: {
                  value: _vm.validForm,
                  callback: function($$v) {
                    _vm.validForm = $$v
                  },
                  expression: "validForm"
                }
              },
              [
                _c(
                  "v-container",
                  [
                    _c(
                      "div",
                      { attrs: { align: "left" } },
                      [
                        _c("v-flex", [
                          _c(
                            "h2",
                            {
                              staticClass: "h2_title",
                              staticStyle: { "margin-top": "12px !important" }
                            },
                            [
                              _vm._v(
                                "\n                General\n              "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    ),
                    _c("v-divider"),
                    _c("br"),
                    _c(
                      "v-layout",
                      { attrs: { wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs4: "", sm4: "", md4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "mr-2",
                              attrs: {
                                name: "numero",
                                label: _vm.formFields.numero.label,
                                disabled: true
                              },
                              model: {
                                value: _vm.formFields.numero.value,
                                callback: function($$v) {
                                  _vm.$set(_vm.formFields.numero, "value", $$v)
                                },
                                expression: "formFields.numero.value"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs4: "", sm4: "", md4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "mr-2",
                              attrs: {
                                name: "movimiento",
                                label: _vm.formFields.usuario.label,
                                disabled: true
                              },
                              model: {
                                value: _vm.formFields.usuario.value,
                                callback: function($$v) {
                                  _vm.$set(_vm.formFields.usuario, "value", $$v)
                                },
                                expression: "formFields.usuario.value"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs4: "", sm4: "", md4: "" } },
                          [
                            _vm.formFields.estado.value != "Ejecutado"
                              ? _c("v-autocomplete", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    name: "movimiento",
                                    label: _vm.formFields.estado.label,
                                    items: _vm.estadosEditables,
                                    disabled: _vm.isAnulado,
                                    rules: [_vm.rules.required]
                                  },
                                  model: {
                                    value: _vm.formFields.estado.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.estado,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.estado.value"
                                  }
                                })
                              : _c("v-text-field", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    name: "movimiento",
                                    label: _vm.formFields.estado.label,
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.formFields.estado.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.estado,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.estado.value"
                                  }
                                })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs4: "", sm4: "", md4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "mr-2",
                              attrs: {
                                name: "movimiento",
                                label: _vm.formFields.cantidad.label,
                                disabled: true
                              },
                              model: {
                                value: _vm.formFields.cantidad.value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formFields.cantidad,
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "formFields.cantidad.value"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs4: "", sm4: "", md4: "" } },
                          [
                            _c("v-autocomplete", {
                              staticClass: "mr-2",
                              attrs: {
                                name: "movimiento",
                                label: _vm.formFields.motivo.label,
                                disabled: _vm.isAnulado || _vm.isEjecutado,
                                items: _vm.findFilterList({ key: "motibaja" }),
                                "item-text": "motiname",
                                "item-value": "motiid",
                                rules: [_vm.rules.required]
                              },
                              on: {
                                keyup: function($event) {
                                  return _vm.$emit(
                                    "motivo",
                                    _vm.formFields.motivo.value
                                  )
                                }
                              },
                              model: {
                                value: _vm.formFields.motivo.value,
                                callback: function($$v) {
                                  _vm.$set(_vm.formFields.motivo, "value", $$v)
                                },
                                expression: "formFields.motivo.value"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs4: "", sm4: "", md4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "mr-2",
                              attrs: {
                                name: "movimiento",
                                label: _vm.formFields.observacion.label,
                                disabled: _vm.isAnulado || _vm.isEjecutado
                              },
                              model: {
                                value: _vm.formFields.observacion.value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formFields.observacion,
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "formFields.observacion.value"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.formFields.numeroBajaCliente.value != ""
                          ? _c(
                              "v-flex",
                              { attrs: { xs4: "", sm4: "", md4: "" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    name: "movimiento",
                                    label:
                                      _vm.formFields.numeroBajaCliente.label,
                                    disabled: true
                                  },
                                  model: {
                                    value:
                                      _vm.formFields.numeroBajaCliente.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.numeroBajaCliente,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formFields.numeroBajaCliente.value"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isAnulado &&
                        _vm.formFields.usuarioModificacion.value != ""
                          ? _c(
                              "v-flex",
                              { attrs: { xs4: "", sm4: "", md4: "" } },
                              [
                                _c(
                                  "v-text-field",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "movimiento",
                                      label:
                                        _vm.formFields.usuarioModificacion
                                          .label,
                                      disabled: true
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.usuarioModificacion
                                          .value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.usuarioModificacion,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.usuarioModificacion.value"
                                    }
                                  },
                                  [_vm._v("\n                >")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isAnulado &&
                        _vm.formFields.fechaModificacion.value != ""
                          ? _c(
                              "v-flex",
                              { attrs: { xs4: "", sm4: "", md4: "" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    name: "movimiento",
                                    label:
                                      _vm.formFields.fechaModificacion.label,
                                    disabled: true
                                  },
                                  model: {
                                    value:
                                      _vm.formFields.fechaModificacion.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.fechaModificacion,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formFields.fechaModificacion.value"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass:
                          "btn-grabar white--text solicitud-baja-sim__edit",
                        attrs: {
                          depressed: "",
                          color: "white",
                          disabled:
                            _vm.isAnulado || !_vm.validForm || _vm.isEjecutado
                        },
                        on: {
                          click: function($event) {
                            return _vm.grabarEdicion()
                          }
                        }
                      },
                      [_c("span", [_vm._v("Guardar Cambios")])]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }